module.exports = __webpack_public_path__ + "static/img/banner_pardon.a396099e.png";